import {camelCase} from "change-case";

let klass = {

    initElements(baseElement)
    {
        // @ugly Using get prototype. Object was empty later?
        // Get loaded components.
        let components = this.getComponents();

        // Loop components.
        for(let [tag, componentImport] of Object.entries(components))
        {
            // Loop relevant elements and init components.
            $(tag, baseElement || window)
                .each((index, element) => this.initVue(element, componentImport));
        }
    },

    getComponents()
    {
        let result = window.Vue.options.components;

        for(var i = 0; Object.values(result).length == 0 && i < 256; i++)
            result = Object.getPrototypeOf(result);

        // TODO High: Error due to empty result?
        if(i >= 255)
            debugger;

        return result;
    },

    initVue(element, componentImport)
    {
        var vueComp = Vue.extend(componentImport);

        new vueComp({
            propsData: this.getProps(element),
            parent: this.getVueParent(element),
        }).$mount(element)
    },

    getVueParent(element)
    {
        while(element.parentNode)
        {
            if(element.__vue__)
                return element.__vue__;

            element = element.parentNode;
        }
    },

    getProps(element)
    {
        let props = {};

        // Loop attributes.
        for (var i = 0; i < element.attributes.length; i++)
        {
            var attrib = element.attributes[i];

            let name = attrib.name;
            let value = attrib.value;

            // Parse JS?
            if(name.startsWith(':')) {
                name = name.substr(1);
                value = JSON.parse(value);
            }

            // Set
            props[camelCase(name)] = value;
        }

        //
        return props;
    }

}

// Export as function.
export default klass.initElements.bind(klass);